import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section id="topics" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-accent-700">
            <i className="ri-grid-line"></i>
            TOPICS
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            按主题分类，逐层拆开
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            六个长期更新的主题方向，覆盖从内容生产到公众讨论的完整链条。选一个你关心的入口开始。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => (
            <a
              key={cat.id}
              href="#articles"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300/70 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={cat.image}
                  alt={`${cat.name}主题配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/75 px-2.5 py-1 text-xs text-background-50">
                  {cat.count} 篇
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <span className="font-heading text-xs text-accent-700">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="h-px flex-1 bg-background-300"></span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600">
                  {cat.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  进入主题
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}